import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Pie, mixins as chartMixins } from "vue-chartjs";
// import "chartjs-plugin-colorschemes";

@Component({
    name: "pie-chart",
})
export default class PieChart extends mixins(Pie, chartMixins.reactiveProp) {
    @Prop()
    public chartData: Chart.ChartData;

    @Prop()
    public options: Chart.ChartOptions;

    @Watch("options", { deep: true })
    public onOptionsChanged(): void {
        this.renderChart(this.chartData, this.options);
    }

    public mounted(): void {
        this.renderChart(this.chartData, this.options);
    }
}
